import { render, staticRenderFns } from "./ModalResident.vue?vue&type=template&id=8249f3d2"
import script from "./ModalResident.vue?vue&type=script&lang=js"
export * from "./ModalResident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports